import { render, staticRenderFns } from "./ModalEditarDocumentoItem.vue?vue&type=template&id=8e99b63a&"
import script from "./ModalEditarDocumentoItem.vue?vue&type=script&lang=js&"
export * from "./ModalEditarDocumentoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports